/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Car\CarData.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday June 22nd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 9th October 2023 05:17:31
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import { Fragment } from "react";
import Styles from "Content/Car/Car.module.css";
import { UpdateCarType } from "Type/CarElement.type.hold";

type CarInfoProps = {
    updatedCarObject: UpdateCarType,
    commentary: string;
    changeCommentary: Function;
    carCustomSubTitle: string;
    changeCarCustomSubTitle: Function;
    dataLeftColumn: JSX.Element[];
    dataRightColumn: JSX.Element[];
    dataPricingLeft: JSX.Element[];
    dataPricingRight: JSX.Element[];
    dataURL: JSX.Element[];
    editable: boolean;
}

function CarInfo(props: CarInfoProps) {

    return(
        <Fragment>
            <div className={`${Styles.dataContainer}`}>
                <div className={`${Styles.bloc}`}>
                    <span className={`${Styles.subTitle}`}>
                        {translator.decode("car.SubTitle")} : <input type="text" disabled={true} className={`${props.carCustomSubTitle.length > 28 ? "flex-grow-1": ""} text-uppercase`} value={props.carCustomSubTitle} onChange={(e) => {props.changeCarCustomSubTitle(e.target.value)}} />
                    </span>
                    <div className={`${Styles.dataHolder}`}>
                        <div className={`${Styles.dataRow}`}>
                            {props.dataLeftColumn}
                        </div>
                        <div className={`${Styles.dataRow}`}>
                            {props.dataRightColumn}
                        </div>
                    </div>
                </div>
                <div className={`${Styles.bloc}`}>
                    <div className={`${Styles.dataHolder} mb-4`}>
                        <div className={`${Styles.dataRow}`}>
                            {props.dataPricingLeft}
                        </div>
                        <div className={`${Styles.dataRow}`}>
                            {props.dataPricingRight}
                        </div>
                    </div>
                    <div className={`${Styles.dataRow}`}>
                        {props.dataURL}
                    </div>
                </div>
            </div>
            <div>
                <h3>{translator.decode("car.Commentary")}</h3>
                <textarea disabled={!props.editable} className="w-100" cols={30} rows={10} value={props.commentary} onChange={(e) => {props.changeCommentary(e.target.value)}}/>
            </div>
        </Fragment>
    )
}

export default CarInfo;
